<script>
  import AddItem from "./actions/AddItem.svelte";
</script>

<AddItem />
